// extracted by mini-css-extract-plugin
export default {"checkout":"CheckoutDetails_checkout__FHb6V","card":"CheckoutDetails_card__ViYW+","select":"CheckoutDetails_select__R-aBI","card-details":"CheckoutDetails_card-details__lt2nY"};